import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import DeleteMail from "src/containers/DeleteMail/DeleteMail";
import { useAppSelector } from "src/custom-hooks/redux/redux";
import { Props } from "./interfaces";
import SendIncomingMail from "./SendIncomingMail";
import { ActionsContainer } from "./styles";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";
import ClassifyMail from "../../../ClassifyMail/ClassifyMail";
import CopyMail from "../../../CopyMail/CopyMail";
import DiscardMail from "../../../DiscardMail/DiscardMail";
import EditIncomingMail from "../../../EditIncomingMail/EditIncomingMail";
const IncomingMailActions = ({ incomingMail, handleNotifyParent, canUpload, canClassify }: Props) => {
  const [closePopover, setClosePopover] = useState<boolean>(false);
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const isAdmin = currentUserAuthorizations?.canChangeAll;

  return (
    <>
      <SimplePopover
        buttonType="icon"
        buttonContent={<FontAwesomeIcon icon={faEllipsisV} />}
        shouldClose={closePopover}
        onOpen={() => setClosePopover(false)}
      >
        <ActionsContainer>
          <EditIncomingMail
            item={incomingMail}
            handleNotifyParent={() => {
              handleNotifyParent();
              setClosePopover(true);
            }}
            readOnly={!canUpload}
          />
          {canUpload && (
            <>
              <CopyMail
                incomingMail={incomingMail}
                handleNotifyParent={() => {
                  handleNotifyParent();
                  setClosePopover(true);
                }}
              />
              <SendIncomingMail
                incomingMail={incomingMail}
                handleNotifyParent={() => {
                  handleNotifyParent();
                  setClosePopover(true);
                }}
              />
            </>
          )}
          {canClassify && (
            <ClassifyMail
              incomingMail={incomingMail}
              handleNotifyParent={() => {
                handleNotifyParent();
                setClosePopover(true);
              }}
            />
          )}

          {canUpload && (
            <DiscardMail
              incomingMail={incomingMail}
              handleNotifyParent={() => {
                handleNotifyParent();
                setClosePopover(true);
              }}
            />
          )}
          {isAdmin && (
            <DeleteMail
              incomingMail={incomingMail}
              handleNotifyParent={() => {
                handleNotifyParent();
                setClosePopover(true);
              }}
            />
          )}
        </ActionsContainer>
      </SimplePopover>
    </>
  );
};

export default IncomingMailActions;
